import { PresetType } from "../PresetSelection";

export interface IPlayerReportDataStreams {
    label: string;
    value: string;
    key: string;
    count: number;
    types: string[];
}

export interface IGeneralReportsConfig {
    report_type?: string,
    group_by_position?: boolean,
    date?: string,
    date_range?: any,
    emails?: any,
    player_report_data_streams?: string[],
    position_filter?: any,
    player_group_filter?: any,
    player_filter?: any,
    comparison_type?: any,
    current_modal_type?: string,
}

export const PLAYER_REPORT_DATA_STREAMS: IPlayerReportDataStreams[] = [
    {
        label: "One-Pager Report Card",
        value: "report-card",
        key: "report-card",
        count: 20,
        types: ["gps", "testing", "forceplate", "nutrition"]
    },
    {
        label: "GPS",
        value: "gps",
        key: "gps",
        count: 4,
        types: ["gps"]
    },
    {
        label: "Forceplate",
        value: "forceplate",
        key: "forceplate",
        count: 4,
        types: ["forceplate"]
    },
    {
        label: "Testing",
        value: "testing",
        key: "testing",
        count: 4,
        types: ["testing"]
    },
]

export interface IReportTypes {
    label: string;
    key: string;
    requirements: string[]
    metric_selector_info?: {
        count: number;
        types: string[];
        useAggs?: boolean;
        show_helper_text?: boolean;
    };
    preset?: {
        key: string;
        presetType: PresetType
    }[];
    teams?: string[];
}

export const REPORT_TYPES: IReportTypes[] = [
    {
        label: 'GPS Report',
        key: 'gps',
        requirements: ['date', 'position_filter', 'player_group_filter', 'emails']
    },
    {
        label: "Coach's Report (GPS)",
        key: 'coach-gps',
        requirements: ['date', 'position_filter', 'player_group_filter', 'emails']
    },
    {
        label: 'Force Plate Report',
        key: 'forceplate',
        requirements: ['date', 'emails', 'group_by_position', 'position_filter', 'player_group_filter', 'comparison', 'metric_selector'],
        metric_selector_info: {
            count: 4,
            types: ['forceplate'],
        },
        preset: [
            {
                key: 'forceplate',
                presetType: PresetType.ForcePlateReportMetrics
            }
        ]
    },
    {
        label: 'Testing Report',
        key: 'testing',
        requirements: ['date', 'emails', 'group_by_position', 'position_filter', 'player_group_filter', 'comparison', 'metric_selector'],
        metric_selector_info: {
            count: 4,
            types: ['testing'],
        },
        preset: [
            {
                key: 'testing',
                presetType: PresetType.TestingReportMetrics
            }
        ]
    },
    {
        label: 'Player Report',
        key: 'player_report',
        requirements: ['single_player_filter', 'player_report_type_selector', 'date_range', 'emails'],
        metric_selector_info: {
            count: 0,
            types: [],
        },
        preset: [
            {
                key: 'report-card',
                presetType: PresetType.PlayerReportMetrics
            },
            {
                key: 'gps',
                presetType: PresetType.GpsReportMetrics
            },
            {
                key: 'forceplate',
                presetType: PresetType.ForcePlateReportMetrics
            },
            {
                key: 'testing',
                presetType: PresetType.TestingReportMetrics
            }
        ]
    },
    {
        label: "Team Report Cards - Bulk Export",
        key: 'report-card-bulk',
        requirements: ['date_range', 'position_filter', 'player_group_filter', 'emails', 'metric_selector'],
        metric_selector_info: {
            count: 20,
            types: ['gps', 'forceplate', 'testing', 'nutrition'],
            useAggs: true,
        },
        preset: [
            {
                key: 'report-card-bulk',
                presetType: PresetType.TeamReportMetrics
            }
        ]
    },
    {
        label: 'Daily Report (All Tech)',
        key: 'daily_all_tech',
        requirements: ['date', 'emails']
    },
    {
        label: 'Wellness Report',
        key: 'wellness',
        requirements: ['date', 'emails']
    },
    {
        label: 'Single Week Distance Breakdown',
        key: 'single_week_distance_breakdown',
        requirements: ['date_range', 'emails'],
        teams: ['Las Vegas Raiders']
    },
    {
        label: 'Multi Week Distance Breakdown',
        key: 'multi_week_distance_breakdown',
        requirements: ['date_range', 'emails'],
        teams: ['Las Vegas Raiders']
    },
    {
        label: 'One Pager Body Weight Report',
        key: 'body_weight_report',
        requirements: ['date_range', 'emails'],
        teams: ['Las Vegas Raiders']
    },
    {
        label: 'Weekly Body Weight Report',
        key: 'weekly_body_weight_report',
        requirements: ['date_range', 'emails'],
        teams: ['Las Vegas Raiders']
    },
    {
        label: 'Custom Breakdown Table',
        key: 'custom_breakdown_table',
        requirements: ['date_range', 'position_filter', 'player_group_filter', 'emails', 'metric_selector'],
        metric_selector_info: {
            count: 6,
            types: ['gps', 'forceplate', 'testing', 'nutrition', 'wellness'],
            useAggs: true,
        },
        preset: [
            {
                key: "custom_breakdown_table",
                presetType: PresetType.CustomBreakdownReportMetrics
            }
        ]
    },
    {
        label: 'Status Report',
        key: 'status_report',
        requirements: ['date_range', 'emails']
    }
];